import React from 'react';

import type { PreviewNode as IPreviewNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';


function PreviewNode(props: WorkflowNodeProps<IPreviewNode>) {
  const { id, type } = props;

  return (
    <BaseNode
      id={id}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-gray-300)',
      }}
      type={type}
    />
  );
}

export default React.memo(PreviewNode);
